const errors = new Map<number, string>();

errors.set(1000, 'La pianificazione dell\'anno corrente non è marcata come completata.');
errors.set(1001, 'La pianificazione dell\'anno successivo non ha almeno un\'azione definita per ogni finalità.');
errors.set(1002, 'La pianificazione dell\'anno successivo non esiste.');

export const getErrorMessage = (code: number): string => {
    const message = errors.get(code);

    if(!message) {
        console.warn(`[Error map] Could not find the code ${code} in errors map.`);
        return '';
    }
    
    return message;
};